// WARNING: This file is auto-generated. Do not modify.
import React, { SVGProps } from 'react';

const ActionAdd = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
    <path d="M20.755 10.755h-7.51v-7.51C13.245 2.56 12.685 2 12 2s-1.245.56-1.245 1.245v7.51h-7.51C2.56 10.755 2 11.315 2 12c0 .342.14.654.366.88.225.225.537.365.88.365h7.509v7.51c0 .342.14.654.366.88.225.225.537.365.879.365.685 0 1.245-.56 1.245-1.245v-7.51h7.51c.685 0 1.245-.56 1.245-1.245s-.56-1.245-1.245-1.245z" />
  </svg>
);

export default ActionAdd;
